<script type="text/jsx">
import ErrorLogo from 'components/svg/ErrorLogo.vue';

export default {
    components: {
        ErrorLogo,
    },

    render() {
        return <div class="error-refresh">
            <div class="modal-heading py-sm">{this.$t('errors.global_error_title')}</div>
            <div class="heading-2 text-center">{this.$t('errors.general_application')}</div>
            <p class="note text-center">{this.$t('errors.click_to_refresh')}</p>
        </div>;
    },
};
</script>
<style lang="scss">
    @import "common/scss/palette";
    @import "common/scss/variables";

    .error-refresh {
        max-width: 460px;
        padding: $pad-lg $pad-lg 0;

        .error-logo {
            width: 165px;
            margin: 0 auto;
            padding-bottom: $pad-md;
        }
    }
</style>
